import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BulkPrice } from '../../../../../model/print-production/bulk-price';

@Component({
  selector: 'app-price-table',
  templateUrl: './price-table.component.html',
  styleUrls: ['./price-table.component.scss'],
})
export class PriceTableComponent {
  @Input() set bulkPrices(value: BulkPrice[]) {
    this._bulkPrices = value.map((bp) => this.roundBulkPrice(bp));
    this.sortBulkPrices();
  }
  get bulkPrices(): BulkPrice[] {
    return this._bulkPrices;
  }
  private _bulkPrices: BulkPrice[] = [];

  @Output() bulkPricesChange = new EventEmitter<BulkPrice[]>();

  private defaultBulkNumbers = [1, 5, 10, 25, 50, 100, 200, 500];

  private roundBulkPrice(bp: BulkPrice): BulkPrice {
    return {
      ...bp,
      bulkNumber: Math.round(bp.bulkNumber || 0),
      unitPrice: Number((Number(bp.unitPrice) || 0).toFixed(2)),
      capShape: Number((Number(bp.capShape) || 0).toFixed(2)),
      descending: Number((Number(bp.descending) || 0).toFixed(2)),
      reflecting: Number((Number(bp.reflecting) || 0).toFixed(2)),
    };
  }

  addRow = (): void => {
    const newBulkNumber = this.getNextAvailableBulkNumber();
    const newBulkPrice = new BulkPrice({ bulkNumber: newBulkNumber });
    const newBulkPrices = [
      ...this.bulkPrices,
      this.roundBulkPrice(newBulkPrice),
    ];
    this.updateBulkPrices(newBulkPrices);
  };

  deleteRow = (bulkNumber: number): void => {
    const newBulkPrices = this._bulkPrices.filter(
      (bp) => bp.bulkNumber !== bulkNumber
    );
    this.updateBulkPrices(newBulkPrices);
  };

  onInputBlur = (
    index: number,
    property: keyof BulkPrice,
    value: any
  ): void => {
    const updatedBulkPrices = [...this._bulkPrices];
    updatedBulkPrices[index] = this.roundBulkPrice({
      ...updatedBulkPrices[index],
      [property]: value,
    });
    this.updateBulkPrices(updatedBulkPrices);
  };

  private updateBulkPrices(newBulkPrices: BulkPrice[]): void {
    this._bulkPrices = newBulkPrices;
    this.sortBulkPrices();
    this.bulkPricesChange.emit(this._bulkPrices);
  }

  private sortBulkPrices(): void {
    this._bulkPrices.sort((a, b) => a.bulkNumber - b.bulkNumber);
  }

  private getNextAvailableBulkNumber(): number {
    const existingBulkNumbers = new Set(
      this._bulkPrices.map((bp) => bp.bulkNumber)
    );
    const availableDefaultNumber = this.defaultBulkNumbers.find(
      (num) => !existingBulkNumbers.has(num)
    );
    return (
      availableDefaultNumber ||
      Math.max(...Array.from(existingBulkNumbers), 0) + 1
    );
  }
}
